import { ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

import CapitalPlans from '@/features/vest-capital/components/capital-plans';

export default function GetFundedPage() {
  return (
    <section className="px-6 py-8 sm:px-8 sm:py-12">
      <div className="mx-auto max-w-5xl">
        <Link to="/deposit" className="flex items-center gap-2">
          <ChevronLeft size={16} />
          Back to Deposit
        </Link>
        <div className="my-8 flex flex-col pb-4">
          <h1 className="mb-4 text-4xl font-bold">Get funded</h1>
          <p className="text-vestgrey-100">
            Choose and complete an evaluation to get funded with our capital.
            Once you pass, you’ll trade live and withdraw profits anytime.
          </p>
        </div>
        <CapitalPlans />
        <p className="mt-4">
          Need more information?{' '}
          <Link
            to="/vest-capital"
            className="inline-block font-semibold underline"
          >
            Learn more
          </Link>
          .
        </p>
      </div>
    </section>
  );
}
